/// <summary>
/// Author: Yong Sheng Chuan
/// </summary>
import axios from 'axios';
import { ApiKey } from './Constant.js';
import * as AppActions from '../redux/AppAction';
import * as AuthActions from '../redux/AuthAction';
import Store from '../ApplicationStore';
import i18n from '../localization/i18n.js'

const _HTTP_CODE_NOT_FOUND = 404;
const _HTTP_CODE_UNAUTHORIZED = 401;
const _HTTP_CODE_NOT_ACCEPTED = 406;

/// <summary>
/// Author: Yong Sheng Chuan
/// </summary>
async function interceptRequest(requestConfig) {
    Store.dispatch(AppActions.setBusy());
    return requestConfig;
}

/// <summary>
/// Author: Yong Sheng Chuan
/// </summary>
function interceptResponse(response) {
    Store.dispatch(AppActions.setIdle());

    return response.data;
}

/// <summary>
/// Author: Yong Sheng Chuan
/// </summary>
function interceptError(error) {
    var returnData = {};

    Store.dispatch(AppActions.setIdle());

    if (error.response.status == _HTTP_CODE_UNAUTHORIZED) {
        Store.dispatch(AuthActions.performLogout());
        Store.dispatch(AppActions.showResponseMessage(false, "DUPLICATE_LOGIN_DETECTED"));
        returnData = {
            "success": false,
            "message": i18n.t("DUPLICATE_LOGIN_DETECTED")
        }
    }
    else if (error.response.status == _HTTP_CODE_NOT_ACCEPTED) {
        Store.dispatch(AuthActions.performLogout());
        Store.dispatch(AppActions.showResponseMessage(false, "ACCOUNT_SUSPENDED"));
        returnData = {
            "success": false,
            "message": i18n.t("ACCOUNT_SUSPENDED")
        }
    }

    return returnData;
}

const ApiEngine = axios.create({
    headers: {
        "X-Requested-With": ApiKey._API_XML_HTTP_REQUEST_KEY
    },
});

ApiEngine.interceptors.request.use(
    config => interceptRequest(config),
    error => interceptError(error),
);

ApiEngine.interceptors.response.use(
    response => interceptResponse(response),
    error => interceptError(error),
);

export default ApiEngine;